import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsVisitationAnimationViewedParams = {
  trail_id: number;
};

/**
 * User scrolls to the the Visitation animation module on TDP. Fire this event when the module is visible.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsVisitationAnimationViewed = ({ trail_id }: logTrailDetailsVisitationAnimationViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details visitation animation viewed', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsVisitationAnimationViewed;
